// extracted by mini-css-extract-plugin
module.exports = {"rating":"Ah","numberOfStars":"Bh"};